import React, { useState, useEffect } from 'react';
import { db } from '../../config/firebase'; // Updated import path
import { collection, getDocs, addDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import img1 from '../../assets/1739276909146.jpg';
import './volunteer.css';

const Volunteer = () => {
    const [opportunities, setOpportunities] = useState([]);
    const [volunteerName, setVolunteerName] = useState('');
    const [email, setEmail] = useState('');
    const [cellNo, setCellNo] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const fetchOpportunities = async () => {
            const querySnapshot = await getDocs(collection(db, 'volunteerOpportunities'));
            const opportunitiesList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setOpportunities(opportunitiesList);
        };

        fetchOpportunities();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await addDoc(collection(db, 'messages'), {
                volunteerName,
                email,
                cellNo,
                message,
                submittedAt: new Date(),
                isRead: false
            });
            alert('Your message has been submitted!');
            setVolunteerName('');
            setEmail('');
            setCellNo('');
            setMessage('');
        } catch (error) {
            console.error('Error adding document: ', error);
            alert('There was an error submitting your message. Please try again.');
        }
    };

    const navigate = useNavigate();

    const handleApplyClick = (volunteerOpportunity) => {
        navigate('/application', { state: { volunteerOpportunity } });
    };

    return (
        <div className='volunteer_container'>
            <div className='volunteer_heading'>
                <h1>be the change</h1>
                <h3>&quot;discover volunteer opportunities with EWCDC and start making an impact today&quot;</h3>
            </div>

            {opportunities.length > 0 && (
                <div className='volunteer_grid'>
                    {opportunities.map((volunteerOpportunity, index) => (
                        <div className='volunteer_card' key={index}>
                            <img src={img1} alt="" />
                            <div className='volunteer_time'>
                                <div className='details'>
                                    <h1>{volunteerOpportunity.title}</h1>
                                    <p>Posted: {volunteerOpportunity.postedDate}</p>
                                </div>
                                <div className='details_time'>
                                    <p>{volunteerOpportunity.isOpen ? 'Application open' : 'Application closed'}</p>
                                </div>
                            </div>
                            <div className='description'>
                                <h1>Description and requirements</h1>
                                <p>{volunteerOpportunity.description}</p>
                            </div>
                            <button className='volunter_btn' onClick={() => handleApplyClick(volunteerOpportunity)}>Apply</button>
                        </div>
                    ))}
                </div>
            )}
            <br/>
            <br/>

            <div className='send_section'>
                <div className='send_section_intro'>
                    <h1>get involved and make a difference!</h1>
                    <p>No current volunteer opportunities posted? No problem! We're always looking for passionate individuals to join our team. If you're interested in volunteering with us, please don't hesitate to reach out. We'll get back to you as soon as possible.</p>
                </div>
                <div className='form_box'>
                    <div className='form_intro'>
                        <h1>send us a message</h1>
                        <p>Use this form on your right side when on large screens, below when on mobile screens to express your interest in volunteering, and we'll be in touch soon!</p>
                    </div>
                    <div className='form_container'>
                        <form onSubmit={handleSubmit}>
                            <label htmlFor="name" className='label_tag'>Name:</label>
                            <input type="text" placeholder='Your name' required className='input_tag' value={volunteerName} onChange={e => setVolunteerName(e.target.value)} />

                            <label htmlFor="email" className='label_tag'>Email:</label>
                            <input type="email" placeholder='Your email' required className='input_tag' value={email} onChange={e => setEmail(e.target.value)} />

                            <label htmlFor="cellno" className='label_tag'>Cell NO:</label>
                            <input type="text" placeholder='Cell number' required className='input_tag' value={cellNo} onChange={e => setCellNo(e.target.value)} />

                            <label htmlFor="message" className='label_tag'>Message:</label>
                            <textarea name="message" className='textarea_tag' value={message} onChange={e => setMessage(e.target.value)}></textarea>

                            <button className='form_btn' type='submit'>Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Volunteer;
